// Cloud-sync loading / error states for the slip lists (UI critique bug-fix batch item C).
// Single job: render the two non-empty "nothing to show yet" states that Bets and History
// share, so a signed-in user never sees a false empty state (or a false "add your first
// slip" pitch) while their bets are in flight or after the fetch failed. Presentational
// only: no data, no hook; the page passes the booleans useCloudSync derives.
import { useState } from "react";
import { JT } from "./jumbotronTokens";

export function SyncSkeleton({ count = 3, height = 120 }) {
  return (
    <div aria-busy="true" aria-label="Loading your slips">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skeleton" style={{ height, borderRadius: JT.radius.card, marginBottom: 10, opacity: .5 }} />
      ))}
    </div>
  );
}

// Copy matches SlipImporter's sync line ("Could not load your slips.") -- one contract, one
// string. Retry disables while the parent's retrySync is pending; a failed retry leaves the
// card up (the hook keeps syncFailed), a successful one unmounts it.
export function SyncErrorCard({ onRetry }) {
  const [retrying, setRetrying] = useState(false);
  const retry = async () => {
    if (retrying || !onRetry) return;
    setRetrying(true);
    try { await onRetry(); } finally { setRetrying(false); }
  };
  return (
    <div role="alert" style={{ background: JT.bg.well, border: `1px solid ${JT.status.lost.border}`, borderRadius: JT.radius.card, padding: "24px", textAlign: "center" }}>
      <div style={{ fontSize: 13, color: JT.status.lost.color, marginBottom: 12 }}>Could not load your slips. Check your connection and try again.</div>
      <button onClick={retry} disabled={retrying} style={{ background: "none", border: `1px solid ${JT.border.mid}`, color: retrying ? JT.text.tertiary : JT.text.secondary, borderRadius: 8, fontSize: 12, fontWeight: 700, padding: "8px 16px", minHeight: 44, cursor: retrying ? "not-allowed" : "pointer", fontFamily: "inherit" }}>
        {retrying ? "Retrying…" : "Retry"}
      </button>
    </div>
  );
}
